import { HubConnectionBuilder, LogLevel, HttpTransportType } from "@microsoft/signalr";
export default {
  install(Vue) {

    const connection = new HubConnectionBuilder()
      .withUrl(`${process.env.VUE_APP_API_BASE_PATH}/userHub`, {
        accessTokenFactory: () => localStorage.getItem("token"),
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets
      })
      .configureLogging(LogLevel.Information)
      .withAutomaticReconnect({
        nextRetryDelayInMilliseconds: retryContext => {
          if (retryContext.elapsedMilliseconds < 60000) {
            // If we've been reconnecting for less than 60 seconds so far,
            // wait between 0 and 10 seconds before the next reconnect attempt.
            return Math.random() * 10000;
          } else {
            // If we've been reconnecting for more than 60 seconds so far, stop reconnecting.
            return null;
          }
        }
      })
      .build();


    const userHub = new Vue();
    Vue.prototype.$userHub = userHub;
    connection.on("ReceiveMessage", (message) => {
      userHub.$emit("receive-message", message);
    });

    // if connection closed, reopen it
    let startedPromise = null;
    function start() {
      if (connection.state != "Connected") {
        startedPromise = connection.start().catch(err => {
          return new Promise((resolve, reject) =>
            setTimeout(
              () =>
                start()
                  .then(resolve)
                  .catch(reject),
              100000
            )
          );
        });
      }
      return startedPromise;
    }

    function invoke(name, input) {

      if (connection.state == "Connected") {
        connection.invoke(name, input)
        console.log("joined the group");

      } else if (connection.state == "Connecting") {

        setTimeout(
          () =>
            invoke(name, input),
          5000
        )
      } else {
        start()
        setTimeout(
          () =>
            invoke(name, input),
          5000
        )
      }
    }
    connection.onclose(() => start());
    userHub.start = () => { console.log("start"); start() };
    userHub.stop = () => { console.log("stop"); connection.stop() };
    userHub.invoke = (name, input) => {
      invoke(name, input)
    };

  }
};